import React from "react";
import { getAppColor } from "@icarius-app/selectors";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { isAfter } from "date-fns";
import { formatDate } from "@icarius-utils/date";
class HolidaysDateRenderer extends React.Component {
    getReactContainerClasses() {
        return ["div-outer-div"];
    }

    render() {
        let isGreaterThanToday = false;

        if (this.props.value && isAfter(new Date(this.props.value), new Date())) {
            isGreaterThanToday = true;
        }

        return this.props.value ? (
            <div style={isGreaterThanToday ? { color: `${this.props.color}` } : {}}>
                <div style={isGreaterThanToday ? { color: `${this.props.color}` } : {}}>
                    {formatDate(this.props.value)}
                </div>
            </div>
        ) : (
            <div></div>
        );
    }
}

export default connect(
    createStructuredSelector({
        color: getAppColor,
    })
)(HolidaysDateRenderer);
